import { Banknote, Skull, KeyRound } from 'lucide-react'
import type { PainPath } from '../types/content'

export const painPaths: PainPath[] = [
  {
    id: 'tonto',
    icon: Banknote,
    label: 'El Camino del Tonto',
    metric: '$1,200 USD',
    metricLabel: 'al mes',
    description:
      'Pagar clínicas boutique por productos que cuestan $90. Usted no financia su biología: financia el mármol del consultorio, la secretaria personal y el agua con infusión de pepino.',
    tone: 'warning'
  },
  {
    id: 'suicida',
    icon: Skull,
    label: 'El Camino del Suicida',
    metric: 'Pureza',
    metricLabel: 'desconocida',
    description:
      'Comprar "Research Grade" en sitios web de dudosa procedencia e inyectarse sustancias sin pureza garantizada, fabricadas en sótanos. Ahorra dinero y apuesta su cuerpo.',
    tone: 'danger'
  },
  {
    id: 'insider',
    icon: KeyRound,
    label: 'El Camino del Insider',
    metric: '$85 – $120',
    metricLabel: 'por vial de farmacia',
    description:
      'Grado médico real, trazable y con certificado de análisis, comprado directamente donde las clínicas se abastecen. Mismo vial, mismo código de barras, sin el sobreprecio del mármol.',
    tone: 'gold'
  }
]
